import $ from 'jquery';
import 'slick-carousel';

export default function initCampaignBannerCarousel() {
    let delay: number;
    let useDots: boolean = true;

    let carouselElement = document.querySelector(`[data-component-part="campaign-banner-carousel"]`) as HTMLElement;
    if (carouselElement) {
        delay = parseInt(carouselElement.dataset.carouselDelay);
        useDots = Boolean(carouselElement.dataset.carouselUseDots).valueOf();
    }

    $('.campaign-banner-carousel').slick({
        dots: useDots,
        arrows: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplaySpeed: delay
    });
}
